import { Reducer } from "redux";

import { EditTrainingVideoResponse } from "../models/api/Training";
import { EditTrainingVideoDispatchTypes } from "../models/dispatchTypes/Training";
import { defaultTrainingVideoResponse, PutTrainingVideoActionDispatchTypes } from "../constants/Training";

const initialState: EditTrainingVideoResponse = {
  loading: false,
  response: defaultTrainingVideoResponse,
  error: null,
};

const EditTrainingVideoReducer: Reducer<
  EditTrainingVideoResponse,
  EditTrainingVideoDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case PutTrainingVideoActionDispatchTypes.PUT_TRAINING_VIDEO_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case PutTrainingVideoActionDispatchTypes.PUT_TRAINING_VIDEO_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case PutTrainingVideoActionDispatchTypes.PUT_TRAINING_VIDEO_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case PutTrainingVideoActionDispatchTypes.PUT_TRAINING_VIDEO_RESET: {
      return initialState;
    }
  }
  return state;
};

export default EditTrainingVideoReducer;
